import React, { useState, useEffect, useCallback } from 'react';
import FlexSelect from 'components/Inputs/FlexSelect';
import { Controller, useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import {
  Row,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Label,
  Form
} from 'reactstrap';

import DefaultModal from 'components/Modal/DefaultModal';
import Pagination from 'components/Pagination';
import ReactButton from 'components/Buttons/ReactButton';
import {
  individual_column_style,
  individual_header_style
} from '../../../../../assets/styles/table_custom_style';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';
import ReactLoader from 'components/Loader';
import BroadcastListService from '../../../service';
import { Button } from 'reactstrap';
import { useSelector } from 'react-redux';

import { FlexSelectSearchTag } from 'components/Inputs/SelectWithSearch';

import CustomFieldsFilterForm from 'views/CRM/shared/components/CustomFieldsFilterForm';
import styled from 'styled-components';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';

import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';
import { FiChevronDown, FiChevronRight } from 'react-icons/fi';
import { FiFilter } from 'react-icons/fi';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { customFieldTypes } from 'views/fieldConfigs/utils/customFieldTypes';
import { parseIntFromString } from 'utils/fuctions/parseIntFromString';
import contactService from 'views/CRM/Contact/services/contactService';
import ModalFilterClients from 'views/Clients/components/ModalFilterClients';
import { SearchContactButton } from 'components/Buttons/SearchContactButton';

const CustomFieldsFilterToggle = styled.div`
  display: inline-block;
  margin-bottom: 1rem;
  user-select: none;
  :hover {
    cursor: pointer;
    text-decoration: underline;
  }
`;

const PAGE_SIZE = 10;

const AddContactsModal = ({
  isModalOpen,
  onModalToggle,
  broadcastListId,
  reloadList,
  ...props
}) => {
  const { control, setValue, getValues, handleSubmit } = useForm();
  const closeModal = useCallback(() => onModalToggle(false), [onModalToggle]);

  const [activePage, setActivePage] = useState(1);
  const [quantity, setQuantity] = useState(0);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [generalContacts, setGeneralContacts] = useState([]);
  const [timeoutID, setTimeoutID] = useState(null);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [isSeletingAll, setIsSeletingAll] = useState(false);
  const [selectedRecordTypeId, setSelectedRecordTypeId] = useState(null);
  const [showCustomFieldsFilters, setShowCustomFieldsFilters] = useState(false);
  const [textQuery, setTextQuery] = useState('');
  const [isClientSearchModalOpen, setIsClientSearchModalOpen] = useState(false);
  const [selectCurrent, setselectCurrent] = useState([]);

  const { recordTypes, getRecordTypesByUser } = useRecordTypesByUser(
    entitiesName.CONTACT
  );

  const systemConfiguration = useSelector((state) => state.systemConfiguration);

  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.CONTACT,
    selectedRecordTypeId
  );

  useEffect(() => {
    getRecordTypesByUser();
    getCustomFields();
  }, [getRecordTypesByUser, getCustomFields]);

  useEffect(() => {
    if (selectedRecordTypeId) {
      setGeneralContacts([]);
    } else if (!selectedRecordTypeId && textQuery.length > 0) {
      handleGetContactsToAdd(1, textQuery);
    } else {
      handleGetContactsToAdd(1);
    }
  }, [selectedRecordTypeId]);

  const onSubmit = async (data) => {
    setLoading(true);
    if (customFields && showCustomFieldsFilters) {
      customFields.forEach((field) => {
        if (field.type === customFieldTypes.LIST) {
          const possibleValues = field.options.map((value) => value.value);
          if (!possibleValues.includes(data[field.name])) {
            data[field.name] = '';
          }
        }
      });
    }
    const currencyFieldsName =
      customFields &&
      customFields
        .filter((field) => field.type === customFieldTypes.CURRENCY)
        .map((field) => field.name);

    let formattedData = { ...data };
    formattedData.textQuery = textQuery;

    Object.keys(data).forEach((key) => {
      if (currencyFieldsName.includes(key)) {
        if (data[key]) {
          formattedData[key] = parseIntFromString(data[key]);
        }
      }
    });

    if (data?.tags) {
      formattedData = {
        ...formattedData,
        tags: data?.tags?.map((tag) => tag.value)
      };
    }

    delete formattedData.recordTypeIds;
    contactService
      .getContacts(selectedRecordTypeId, formattedData, {
        activePage,
        limit: PAGE_SIZE
      })
      .then((response) => {
        const contactsDTO = response.data.data.filter(
          (contact) => contact.id_whatsapp
        );
        setGeneralContacts(contactsDTO);
        setQuantity(contactsDTO.length);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (selectedRows) {
      setselectCurrent(selectedRows);
    }
  }, [selectedRows]);

  const handleGetContactsToAdd = useCallback(
    (page, q = '') => {
      setLoading(true);

      const params = {
        page,
        size: PAGE_SIZE,
        ignoringFrom: broadcastListId,
        q
      };

      BroadcastListService.getContacts(params)
        .then((response) => {
          const { count, registers } = response.data;
          setQuantity(count);
          setGeneralContacts(registers);
        })
        .catch(() => {
          toast.error('Erro ao listar contatos');
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [broadcastListId]
  );

  useEffect(() => {
    if (isModalOpen) {
      setTextQuery('');
      setSelectedRecordTypeId(null);
      handleGetContactsToAdd(1);
    }

    return () => {
      setSelectedRows([]);
      setActivePage(1);
    };
  }, [isModalOpen, handleGetContactsToAdd]);

  useEffect(() => {
    if (selectedRows.length === quantity) {
      setIsAllSelected(true);
    } else {
      setIsAllSelected(false);
    }
  }, [quantity, selectedRows.length]);

  const handleAddContacts = () => {
    if (!selectedRows?.length) return;

    const clients = selectedRows.map((client) => ({
      id: client.id,
      name: client.nome
    }));

    setSelectedRows([]);

    BroadcastListService.addContactsToBroadcastList(broadcastListId, clients)
      .then(() => {
        toast.success('Contato(s) adicionado(s) com sucesso');
        reloadList(1);
        closeModal();
      })
      .catch((error) => {
        const msg = error?.response?.data?.message;
        toast.error(msg || 'Ocorreu um erro ao adicionar o(s) contato(s)');
      });
  };

  const handleOnSelect = (row, isNotSelectedYet) => {
    if (isNotSelectedYet) {
      const newSelected = {
        id: row.id,
        nome: row.nome || row.name,
        id_whatsapp: row.id_whatsapp
      };
      setSelectedRows([...selectedRows, newSelected]);
    } else {
      setSelectedRows(selectedRows.filter((x) => x.id !== row.id));
    }
  };

  const handleOnSelectAll = (isSomeSelected, rows) => {
    if (isSomeSelected) {
      const allRows = [...selectedRows, ...rows].map((r) => {
        return {
          id: r.id,
          nome: r.nome || r.name,
          id_whatsapp: r.id_whatsapp
        };
      });
      setSelectedRows(allRows);
    } else {
      const idsToRemove = rows.map((row) => row.id);
      setSelectedRows((currentSelected) => {
        return currentSelected.filter(({ id }) => !idsToRemove.includes(id));
      });
    }
  };

  const handlePageChange = (activePage) => {
    setActivePage(activePage);
    handleGetContactsToAdd(activePage);
  };

  //apenas fazer a busca caso não tenha tipo de registro selecionado
  const handleOnSearch = (event) => {
    if (selectedRecordTypeId) {
      setTextQuery(event.target.value);
      return;
    } else {
      if (typeof timeoutID === 'number') {
        clearTimeout(timeoutID);
      }
      const q = event.target.value;
      setTimeoutID(
        setTimeout(() => {
          handleGetContactsToAdd(1, q);
        }, 1000)
      );
    }
  };

  const handleSelectAll = () => {
    if (isAllSelected) {
      setSelectedRows([]);
      setIsAllSelected(false);
      return;
    }

    setIsSeletingAll(true);

    BroadcastListService.getContacts({ ignoringFrom: broadcastListId })
      .then((response) => {
        const { registers } = response.data;
        if (!registers) return;

        const registersSelectionDTO = registers.map((row) => ({
          id: row.id,
          nome: row.nome,
          id_whatsapp: row.id_whatsapp
        }));

        setIsAllSelected(true);
        setSelectedRows(registersSelectionDTO);
      })
      .catch(() => {
        toast.error('Erro ao selecionar todos os contatos');
      })
      .finally(() => {
        setIsSeletingAll(false);
      });
  };

  const toISOFormat = useCallback((dateTimeString, bar = false) => {
    const [date] = dateTimeString.split(' ');
    const [DD, MM, YYYY] = date.split('/');
    if (bar) return `${YYYY}/${MM}/${DD}`;
    return `${DD}/${MM}/${YYYY}`;
  }, []);

  const createDynamicColumns = () => {
    const columns = [];

    if (selectedRecordTypeId) {
      columns.push({
        dataField: 'name',
        text: 'Nome',
        sort: true,
        style: individual_column_style,
        headerStyle: individual_header_style
      });
    } else {
      columns.push({
        dataField: 'nome',
        text: 'Nome',
        sort: true,
        style: individual_column_style,
        headerStyle: individual_header_style
      });
    }

    columns.push({
      dataField: 'id_whatsapp',
      text: 'Telefone',
      style: individual_column_style,
      headerStyle: individual_header_style
    });

    return [...columns];
  };

  const dynamicFunctionColumns = createDynamicColumns();

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Adicionar contatos à Campanha Ativa Whatsapp"
      showCloseButton={false}
      modalContainerClasses="modal-xl"
      {...props}
    >
      <ModalFilterClients
        className="modal-lg"
        show={isClientSearchModalOpen}
        onModalToggle={setIsClientSearchModalOpen}
        isBroadcastList={true}
        selectCurrent={selectCurrent}
        setSelectedClient={(a) => {
          setSelectedRows((prevSelectedRows) => {
            const alreadyExists = prevSelectedRows.some(
              (row) => row.id === a.clientId
            );

            if (!alreadyExists) {
              return [
                ...prevSelectedRows,
                { id: a.clientId, nome: a.clientName }
              ];
            }

            return prevSelectedRows;
          });

          setIsClientSearchModalOpen(false);
        }}
      />
      <>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row>
            <Col className="d-flex flex-row justify-content-between">
              <div>
                <strong>
                  {selectedRows.length || '0'}
                  {`/${quantity} `}
                </strong>
                {selectedRows.length === 1 ? 'novo' : 'novos'} contatos
                selecionados
              </div>
              <ReactButton
                btnColor="confirmation"
                type="submit"
                size="sm"
                disabled={!selectedRows || !selectedRows.length}
                onClick={handleAddContacts}
              >
                Salvar Selecionados
              </ReactButton>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md={7}>
              <label htmlFor="search">Pesquisar</label>
              <InputGroup>
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input
                  size="md"
                  placeholder={
                    selectedRecordTypeId
                      ? 'Buscar por nome, telefone ou email'
                      : 'Buscar por nome ou telefone'
                  }
                  type="text"
                  defaultValue=""
                  onChange={handleOnSearch}
                />
              </InputGroup>
              <div
                style={{
                  position: 'absolute',
                  right: '-35px',
                  top: '50%',
                  transform: 'translateY(-50%)'
                }}
              >
                <SearchContactButton
                  onClick={() => setIsClientSearchModalOpen(true)}
                />
              </div>
            </Col>
            <Col md={4} style={{ marginRight: '3rem' }}>
              <FormGroup>
                <label htmlFor="recordTypeIds">Tipos de registro</label>
                <Controller
                  render={(props) => (
                    <FlexSelect
                      dataOptions={recordTypes || []}
                      isMulti={false}
                      closeMenuOnSelect={true}
                      value={props.value}
                      valueController={(field, value) => {
                        setValue(field, value);
                        setSelectedRecordTypeId(value);
                      }}
                      fieldName="recordTypeIds"
                      labelName="name"
                      valueName="id"
                      isClearable={true}
                    />
                  )}
                  control={control}
                  name="recordTypeIds"
                  defaultValue=""
                />
              </FormGroup>
            </Col>
          </Row>
          {selectedRecordTypeId && (
            <div>
              <Row className="mt-2">
                <Col md={4}>
                  <Controller
                    render={(props) => (
                      <FlexSelectSearchTag
                        setValueSelected={(data) => {
                          setValue('tags', data);
                        }}
                        value={props.value}
                        fieldName="tags"
                        defaultValue=""
                        // defaultValue={props.value}
                      />
                    )}
                    control={control}
                    name="tags"
                    defaultValue=""
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  {customFields && customFields.length > 0 && (
                    <>
                      <CustomFieldsFilterToggle
                        className="small"
                        onClick={() =>
                          setShowCustomFieldsFilters(!showCustomFieldsFilters)
                        }
                      >
                        Filtrar por campos customizados{' '}
                        {showCustomFieldsFilters ? (
                          <FiChevronDown size={18} />
                        ) : (
                          <FiChevronRight size={18} />
                        )}
                      </CustomFieldsFilterToggle>

                      {showCustomFieldsFilters && (
                        <CustomFieldsFilterForm
                          toISOFormat={toISOFormat}
                          getValues={getValues}
                          customFields={customFields}
                          setValue={setValue}
                          control={control}
                        />
                      )}
                    </>
                  )}
                </Col>
              </Row>
              <Button
                style={buttonStyle(systemConfiguration.primary_color)}
                type="submit"
                size="md"
                disabled={loading}
              >
                <FiFilter />
                <span className="ml-1">Filtrar Contatos</span>
              </Button>
            </div>
          )}
        </Form>
        {!selectedRecordTypeId && (
          <Row className="mt-2 pl-3 small">
            <Col>
              <FormGroup check>
                <Label
                  style={{
                    cursor: isSeletingAll || quantity < 1 ? 'auto' : 'pointer'
                  }}
                  check
                >
                  <Input
                    type="checkbox"
                    checked={isAllSelected}
                    onChange={handleSelectAll}
                    disabled={isSeletingAll || quantity < 1}
                  />
                  <span
                    style={{ userSelect: 'none' }}
                  >{`Selecionar todos (${quantity})`}</span>
                </Label>
              </FormGroup>
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <ToolkitProvider
              data={generalContacts || []}
              keyField="id"
              loading={loading}
              columns={dynamicFunctionColumns}
            >
              {(props) => (
                <div className="py-4 table-responsive">
                  {loading ? (
                    <Row className="justify-content-md-center">
                      <ReactLoader />
                    </Row>
                  ) : (
                    <BootstrapTable
                      selectRow={{
                        mode: 'checkbox',
                        selected: selectedRows.map((r) => r.id),
                        onSelect: handleOnSelect,
                        onSelectAll: handleOnSelectAll,
                        selectColumnStyle: individual_header_style
                      }}
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  )}
                </div>
              )}
            </ToolkitProvider>
          </Col>
        </Row>
        <Pagination
          activePage={activePage}
          itemsCountPerPage={PAGE_SIZE}
          totalItemsCount={quantity}
          onChange={handlePageChange.bind(this)}
        />
      </>
    </DefaultModal>
  );
};

export default AddContactsModal;
